import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "display-block-media-1200 cart-result-discount mb-3 pb-3 pt-3 bb-solid-white100 bt-solid-white100" }
const _hoisted_2 = { class: "mt-2 mb-2 d-flex" }
const _hoisted_3 = {
  type: "button",
  class: "btn btn-default-inactive btn-apply-discount"
}

import { Field } from "vee-validate";

export default /*#__PURE__*/_defineComponent({
  __name: 'cartDiscount',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Field), {
        type: "text",
        class: "w-100 bg-status-gray50 input input-discount mr-1",
        placeholder: _ctx.$tc('Add discount code') || '',
        disabled: "",
        name: 'discount'
      }, null, 8, ["placeholder"]),
      _createElementVNode("button", _hoisted_3, _toDisplayString(_ctx.$tc("Apply")), 1)
    ])
  ]))
}
}

})